import {
  createContext,
} from 'react'

const RegistrationContext = (
  createContext({
    registerFieldName: () => {},
  })
)

export default RegistrationContext
